module.exports = __webpack_public_path__ + "static/img/freshman-blocky-hover.3f9ab70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-blocky-hover.png
// module id = zjJt
// module chunks = 1